
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'


const HelmetWidget = (props) => {
	var pageTitle = props.pageTitle;
	pageTitle = props.path === "" ? pageTitle : pageTitle + " - IperBTP";
	return (
		<Helmet>
			<title>{pageTitle}</title>
			<meta name="description" content={props.description} />
			<meta name="keywords" content="IperBTP, formation, sécurité, incendie, amiante, ss3, ss4, prévention, risques, professionnels" />
			<meta property="og:title" content={pageTitle + "- IperBTP"} />
			<meta property="og:type" content="website" />
			<meta property="og:image" content="/favicon.png" />
			<meta property="og:description" content={props.description} />
			<meta charset="utf-8" />
			<meta http-equiv="X-UA-Compatible" content="IE=edge" />
			<meta property="og:locale" content="fr_FR" />
			<meta property="og:site_name" content="IperBTP" />
			<meta property='og:url' content={"https://iperbtp.fr/" + props.path} />
			<meta name="viewport" content="width=device-width, initial-scale=1" />
			<link rel="canonical" href={"https://iperbtp.fr/" + props.path} />
			<link rel="icon" type="image/x-icon" href="/favicon.png" />
		</Helmet>
	)
}

HelmetWidget.propTypes = {
	pageTitle: PropTypes.string,
	description: PropTypes.string,
	path: PropTypes.string
}

HelmetWidget.defaultProps = {
	pageTitle: "IperBTP",
	description: "IperBTP est un organisme de formation spécialisé dans la prévention des risques professionnels. Nous proposons des formations en sécurité incendie, en premiers secours et en prévention des risques professionnels notamment lié à l'amiante SS3 et SS4.",
	path: ""
}



export default HelmetWidget